import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UNIT_DETAILS_ROUTE } from '../shared/constants/routes';
import { UnitDetailsComponent } from './unit-details/unit-details.component';

const routes: Routes = [
  {
    path: `${UNIT_DETAILS_ROUTE}/:unit_id`,
    component: UnitDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UnitDetailsRoutingModule {}
